 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP71683 from '@/components/chap71683'
 import CHAP71682 from '@/components/chap71682'
 import CHAP71684 from '@/components/chap71684'
 import CHAP75828 from '@/components/chap75828'
 import CHAP71435 from '@/components/chap71435'
 import CHAP75837 from '@/components/chap75837'
 import CHAP75838 from '@/components/chap75838'
 import CHAP75839 from '@/components/chap75839'
 import CHAP75841 from '@/components/chap75841'
 import CHAP75842 from '@/components/chap75842'
 import CHAP75844 from '@/components/chap75844'
 import CHAP75845 from '@/components/chap75845'
 import CHAP75846 from '@/components/chap75846'
 import CHAP75827 from '@/components/chap75827'
 import CHAP71434 from '@/components/chap71434'
 import CHAP75859 from '@/components/chap75859'
 import CHAP75851 from '@/components/chap75851'
 import CHAP75852 from '@/components/chap75852'
 import CHAP75853 from '@/components/chap75853'
 import CHAP75854 from '@/components/chap75854'
 import CHAP75855 from '@/components/chap75855'
 import CHAP75862 from '@/components/chap75862'
 import CHAP75857 from '@/components/chap75857'
 import CHAP75858 from '@/components/chap75858'
 import CHAP75867 from '@/components/chap75867'
 import CHAP71436 from '@/components/chap71436'
 import CHAP75869 from '@/components/chap75869'
 import CHAP75884 from '@/components/chap75884'
 import CHAP75885 from '@/components/chap75885'
 import CHAP75886 from '@/components/chap75886'
 import CHAP71438 from '@/components/chap71438'
 import CHAP75888 from '@/components/chap75888'
 import CHAP71437 from '@/components/chap71437'
 import LOVE_2 from '@/components/love_2'
 import CHAP106971 from '@/components/chap106971'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap71683",
 			"name" : "chap71683",
 			"component" : CHAP71683
 		},
 		{
 			"path" : "/chap71682",
 			"name" : "chap71682",
 			"component" : CHAP71682
 		},
 		{
 			"path" : "/chap71684",
 			"name" : "chap71684",
 			"component" : CHAP71684
 		},
 		{
 			"path" : "/chap75828",
 			"name" : "chap75828",
 			"component" : CHAP75828
 		},
 		{
 			"path" : "/chap71435",
 			"name" : "chap71435",
 			"component" : CHAP71435
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js